import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconPin, IconPinned } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
import { pinUser, unpinUser } from '../../../inklusiva/pinuser/actions';
import { isUserPinned } from '../../../inklusiva/pinuser/functions';
const useStyles = makeStyles()(() => {
    return {
        pinUserButton: {
            padding: '3px !important',
            borderRadius: '4px',
            '& svg': {
                width: '18px',
                height: '18px'
            }
        }
    };
});
const PinUserButton = ({ visible, _userPinned, participantId }) => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const _onClick = (e) => {
        e.stopPropagation();
        if (_userPinned) {
            dispatch(unpinUser(participantId ?? null));
        }
        else {
            dispatch(pinUser(participantId ?? null));
        }
    };
    return visible ? (React.createElement(Button, { accessibilityLabel: 'Nutzer anpinnen', className: classes.pinUserButton, icon: _userPinned ? IconPinned : IconPin, 
        // eslint-disable-next-line react/jsx-no-bind
        onClick: _onClick, size: 'small' })) : null;
};
function _mapStateToProps(state, ownProps) {
    const userPinned = isUserPinned(state, ownProps.participantId);
    return {
        visible: userPinned
            || (ownProps.visible && state['features/base/participants'].local?.id !== ownProps.participantId),
        participantId: ownProps.participantId,
        _userPinned: userPinned
    };
}
export default connect(_mapStateToProps)(PinUserButton);
